import CoursesMenu from "./courses-menu";

export default class CoursesMenuDesktop extends CoursesMenu {
	constructor($root) {
		super($root);

		this.$trigger = null;
		this.$mainContent = null;

		this.mainContentMinHeight = null;
	}

	init() {
		super.init();

		setTimeout(() => {
			const $catsList = this.$categoriesMenu.querySelector('.cats-list');
			const $subcatsNav = this.$root.querySelector('.subcats-nav');

			this.mainContentMinHeight = this.$searchField.offsetHeight + $catsList.offsetHeight + 45;

			if ($subcatsNav) {
				$subcatsNav.style.minHeight = this.mainContentMinHeight + 'px';
			}
			this.changeMainContentHeight(true);
		}, 150);
	}

	defineViews() {
		super.defineViews();

		this.$trigger = document.getElementById('coursesMenuDesktopTrigger');
		this.$mainContent = document.getElementById('coursesMenuMainContent');
	}

	setInitialState() {
		let historyData = sessionStorage.getItem('coursesMenu');

		if (!historyData) {
			return super.setInitialState();
		}

		historyData = JSON.parse(historyData);

		if (historyData.category === 'search-panel') {
			this.activeScreenId = this.defaultScreenId;
		} else {
			this.activeScreenId = historyData.category;
		}

		if (historyData.subcategory) {
			this.initialSubcategory = historyData.subcategory;
		}

		super.setInitialState();
	}

	setActiveScreen(id) {
		super.setActiveScreen(id);

		const currentSubcatController = this.subcategoryControllers
			.find((controller) => (controller.id === id));

		let subcatId = null;

		if (currentSubcatController) {
			subcatId = currentSubcatController.currentSubcategoryId;
		}

		this.addHistoryRecord(id, subcatId);
	}

	refreshActiveScreen() {
		super.refreshActiveScreen();
		this.changeMainContentHeight();
	}

	activateSearchPanel() {
		super.activateSearchPanel();
		this.changeMainContentHeight();
		this.addHistoryRecord('search-panel');
	}

	changeMainContentHeight(noTransition = false) {
		let $activeScreen = this.$mainContent.querySelector('.courses-nav-screen.-active');

		if (!$activeScreen) {
			$activeScreen = this.$mainContent.querySelector('.search-panel.-active');
		}

		if (!$activeScreen) return;

		if (noTransition) {
			this.$mainContent.classList.add('-notransition');
		} else {
			this.$mainContent.classList.remove('-notransition');
		}

		const activeScreenHeight = $activeScreen.offsetHeight;
		let newHeight = activeScreenHeight > this.mainContentMinHeight ?
			activeScreenHeight : this.mainContentMinHeight;
		this.$mainContent.style.height = `${newHeight}px`;
	}

	handleSubcategoryChange(subcatId) {
		super.handleSubcategoryChange(subcatId);
		this.addHistoryRecord(this.activeScreenId, subcatId);
		this.changeMainContentHeight();
	}

	/* Remembers user's last choice */
	addHistoryRecord(category, subcategory = null) {
		const payload = { category, subcategory };
		sessionStorage.setItem('coursesMenu', JSON.stringify(payload));
	}
}